var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppelIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.25H13V13.375C13 13.6734 12.8815 13.9595 12.6705 14.1705C12.4595 14.3815 12.1734 14.5 11.875 14.5C11.5766 14.5 11.2905 14.3815 11.0795 14.1705C10.8685 13.9595 10.75 13.6734 10.75 13.375V9.25Z",
    stroke: "#EB2630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 3.25H13.375C13.6734 3.25 13.9595 3.36853 14.1705 3.5795C14.3815 3.79048 14.5 4.07663 14.5 4.375V8.125C14.5 8.42337 14.3815 8.70952 14.1705 8.9205C13.9595 9.13147 13.6734 9.25 13.375 9.25H9.25",
    stroke: "#EB2630",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H3.25C2.65326 4 2.08097 4.23705 1.65901 4.65901C1.23705 5.08097 1 5.65326 1 6.25C1 6.84674 1.23705 7.41903 1.65901 7.84099C2.08097 8.26295 2.65326 8.5 3.25 8.5H4",
    stroke: "#EB2630",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07425 11.125C4.05462 11.1248 4.03585 11.1169 4.02196 11.103C4.00808 11.0892 4.0002 11.0704 4 11.0507V1.07425C4 1.033 4.03337 1 4.07425 1H5.3125C8.1085 1 10.375 3.2665 10.375 6.0625C10.375 8.8585 8.1085 11.125 5.3125 11.125H4.07425Z",
    stroke: "#EB2630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppelIconActive);
export default __webpack_public_path__ + "static/media/AppelIconActive.6fe1d2a2942ab35c0c362b020e12617a.svg";
export { ForwardRef as ReactComponent };